import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Warranty } from '../../models/warranty-type/warranty-model';
import { ProductService } from '../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-warranty-create',
    templateUrl: './warranty-create.component.html',
    styleUrls: ['./warranty-create.component.css']
})
/** warranty-create component*/
export class WarrantyCreateComponent {
    /** warranty-create ctor */
  public warranty = new Warranty();
  validate: boolean;
  constructor(private readonly productService: ProductService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("warrantyType").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            
            this.toastr.setRootViewContainerRef(vcr);
            this.warranty.isActive = true;
            this.validate = true;
          }
          else {
            this.router.navigate(["/warranty-list"]);
          }
        }
        else {
          this.router.navigate(["/warranty-list"]);
        }
      }
    )

  }
  isActiveCheckbox(e) {
    this.warranty.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.productService.addWarrantyType(this.warranty).subscribe(result => {
      if (result) {
        this.toastr.success('Warranty Type has been Saved.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/warranty-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/warrantyType/warranty-create/warranty-create.component.ts